import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../../environments/environment";
import { LiveProductionSnapshotPayload } from "../models/live-production.model";

@Injectable({ providedIn: "root" })
export class LiveProductionApiService {
  private httpClient = inject(HttpClient);

  /**
   * Snapshot agrégé de toutes les lignes de production avec leur état
   * (EN_PROD / RALENTI / EN_ATTENTE / HORS_PLAGE / INACTIF), OF actif,
   * conducteur, et cible cadence.
   */
  snapshot(): Observable<LiveProductionSnapshotPayload> {
    return this.httpClient.get<LiveProductionSnapshotPayload>(
      `${environment.api()}/live-production/snapshot`,
    );
  }
}
